import { CellMeasurerCache } from 'react-virtualized';
import { CfDataGridRowType, CfRowData } from '../CfDataGridProps';

export const getEstimatedRowHeight = (
  rows: CfRowData[],
  cache: CellMeasurerCache,
  getEstimatedAverageRowHeight: ((type: CfDataGridRowType) => number) | undefined,
  isLoadingPrevious: boolean
): number | undefined => {
  let totalHeight = 0;
  let missingAnyRowHeights = false;
  for (let i = 0; i < rows.length && !missingAnyRowHeights; i++) {
    const rowType = rows[i].type;
    let rowHeight = getEstimatedAverageRowHeight?.(rowType);
    if (!isLoadingPrevious && cache.has(i, 0)) {
      rowHeight = cache.rowHeight({ index: i });
    }
    if (rowHeight === undefined) {
      missingAnyRowHeights = true;
    } else {
      totalHeight += rowHeight;
    }
  }
  if (!missingAnyRowHeights && rows.length > 0) {
    return totalHeight / rows.length;
  }
};
